import React from "react";
import { Navigate } from "react-router-dom";
import { IsAuthenticated } from "./utils/_helpers";

const PublicRoute = ({ children, forcePublic = false }) => {
  return IsAuthenticated() && !forcePublic ? (
    <Navigate to="/list-opportunities" />
  ) : (
    children
  );
};

export default PublicRoute;
